import React from "react";
import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalApplicationState } from "globalApplicationState";
import { useDispatch, useSelector } from "react-redux";
import { emailsSlice } from "../reducer";

import "../styles/emailTemplateModal.sass";

interface IEmailTemplateModalProps {
    show: boolean;
    onClose: () => void;
    onSelectEmailTemplate: () => void;
}

const EmailTemplateModal: React.FC<IEmailTemplateModalProps> = ({
    show,
    onClose,
    onSelectEmailTemplate
}) => {
    const { templates } = useSelector((state: GlobalApplicationState) => state.emails.emailTemplates);
    const dispatch = useDispatch();

    const onClickEmailTemplate = (templateFileName?: string) => {
        dispatch({ type: emailsSlice.actions.SET_SELECTED_EMAIL_TEMPLATE_FILE_NAME, payload: { selectedTemplateFileName: templateFileName } });
        onSelectEmailTemplate();
    }

    const getGridItem = (templateThumbnailUrl: string, templateDisplayName: string, templateFileName?: string) => <Grid 
        item
        xs={6}
        key={templateDisplayName} 
        className="email-template-item"
    >
        <div className="email-template-image-container" onClick={() => onClickEmailTemplate(templateFileName)}>
            <Button className="email-template-button" variant="contained" color="primary">
                Select
            </Button>
            <img src={templateThumbnailUrl} alt={templateDisplayName} className="email-template-image"/>
        </div>
        <span className="email-template-name">{templateDisplayName}</span>
    </Grid>

    return <Dialog 
        open={show} 
        onClose={onClose}
        className="email-template-dialog"
        maxWidth="lg"
        classes={{ paper: "email-template-dialog-paper" }}
    >
        <DialogTitle className="email-template-dialog-title">
            <div className="title-text-container">
                Select Template
            </div>
            <IconButton onClick={onClose} size="large" edge="end">
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent className="email-template-dialog-content">
            <Grid container spacing={2} className="email-template-grid">
                {
                    getGridItem("/images/startFromScratchThumbnail.png", "Start from Scratch")
                }
                {
                    templates.map(template => getGridItem(template.thumbnailUrl, template.displayName, template.ospreyFileName))
                }
            </Grid>
        </DialogContent>
    </Dialog>;
};

export default EmailTemplateModal;
